export const colors = {
  blues: {
    main: "rgba(20, 30, 210, 1)",
  },
  pinks: {
    main: "rgba(234, 132, 171, 1)",
  },
  white: "#fff",
  blacks: {
    textHeader: "#112843",
  },
  text:{
    main:"#000000",
    black1:"",
    blueMain:"rgba(20, 30, 210, 1)",
    blue2: '#4C51F5',
    pinkDark:"#EA84AB",
    lightBlue: '#009FFF',
    disabled: '#E0E0E0',
  },
  background:{
    blueMain:"#DD0071",
    blueButton:"#DD0071",
    pinkBlur:"#FEF3F3",
    pink:"#F2A3B9",
    pinkDark:"#EA84AB",
    gray: '#E0E0E0',
    white: '#fff',
    grayBlur: 'rgba(245, 245, 245, 0.7)',
  },
  line:{
    grayDark:"rgba(224, 224, 224, 1)"
  },
  border:{
    pink:'#F2A3B9',
    pinkDark:"#EA84AB",
    lightBlue: '#009FFF',
  }
};
